<!------------------------------------------------------------------------------
 File: SearchUser 
 Created by keni.
 with: IntelliJ IDEA
 Date: 09/04/2018
 Time: 14:42
------------------------------------------------------------------------------->
<template>
    <div class=" ">
        <search-bar @search_event="searchEvent"
                    @close_search_event="closeSearch()"
                    close_search_action="close_search_action"
                    open_on_load="true"
                    :min_input="min_input"
                    :label="setLabel()"
        ></search-bar>
        <div>
            <transition-group name="fade" tag="div">
                <div class="d-flex justify-content-between align-items-center"
                     v-for="selected_user,index in selected_users"
                     :key="index"
                >
                    <div class="d-inline-block">
                        {{selected_user.email}}
                    </div>
                    <div class="d-inline-block btn btn-sm btn-primary"
                         v-on:click="removeUserFromSubmissionList(selected_user)"
                    >
                        <i class="material-icons">delete</i>
                    </div>
                    <input v-if="form_input!==''" type="hidden" :name="form_input" v-model="selected_user.id">
                </div>
            </transition-group>
        </div>
        <transition name="fade">
            <BaseLoadingAnimation v-if="searching===true"></BaseLoadingAnimation>
        </transition>
        <transition name="fade">
            <table v-if="!isEmpty(users)" class="table w-auto table-striped table-bordered">
                <thead>
                <tr>
                    <th>First</th>
                    <th>Last</th>
                    <th>Email</th>
                    <th v-if="settings.show_roles">Roles</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in users" :class="{
                    'table-primary':userInSelected(user),
                    'cursor-pointer':userInSelected(user),
                    }"
                    v-on:click="toggleUserToListSubmissionList(user)"
                >
                    <td>{{user.first_name}}</td>
                    <td>{{user.last_name}}</td>
                    <td>{{user.email}}</td>
                    <td v-if="settings.show_roles">
                        <div v-for="role in user.roles">
                            <span>[ {{role.name}} ]</span>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </transition>
    </div>
</template>

<script>
    import {_} from 'underscore';

    window.Vue.component('table-search', require('../../tables/tableSearch'));
    window.Vue.component('search-bar', require('../../../../../../app/Shared/Resources/Assets/js/components/SearchBar'));

    export default {
        name: "search-user",
        components: {},
        props: [
            'table_laravel_route_uri',
            'table_request_route_url',
            'table_crud',
            'search_user_uri',
            'options',

        ],
        created() {
        },
        destroyed() {
        },
        mounted() {
            // console.log(typeof this.options)
            let propsOptions = (typeof this.options != 'object') ? JSON.parse(this.options) : this.options;

            if ('show_roles' in propsOptions) {
                this.settings.show_roles = propsOptions.show_roles;
            }
            if ('select_row' in propsOptions) {
                this.settings.select_row = propsOptions.select_row;
            }
            if ('form_input' in propsOptions) {
                this.form_input = propsOptions.form_input;
            }
        },
        data() {
            return {
                user: '',
                users: [],
                settings: {
                    show_roles: false,
                    select_row: false,
                },
                form_input: '',
                selected_users: [],
                min_input: 6,
                searching: false

            }
        },
        methods: {
            setLabel() {
                // console.log('setLabel', 'this.options', typeof this.options);
                if (typeof this.options !== 'undefined' && this.options !== null) {
                    let options = (typeof this.options != 'object') ? JSON.parse(this.options) : this.options;
                    if ('search_input_label' in options) {
                        return options.search_input_label;
                    }
                    // console.log('setLabel', 'options',options);
                }
                return '';
            },
            emit_selected_users() {
                this.$emit('selected_user_emit', this.selected_users);
            },
            userInSelected(user) {
                if (this.settings.select_row !== true) {
                    return;
                }
                let self = this,
                    currentUser = user,
                    test = _.filter(self.selected_users, function (userTest) {
                        if (currentUser.id == userTest.id) {
                            return true;
                        }
                    });

                return (!_.isEmpty(test));
            },
            toggleUserToListSubmissionList(user) {
                if (!this.userInSelected(user)) {
                    this.selected_users.push(user);
                    this.emit_selected_users();
                } else {
                    this.removeUserFromSubmissionList(user);
                }
            },
            removeUserFromSubmissionList(user) {
                let index = this.selected_users.indexOf(user);

                this.selected_users.splice(index, 1);
                this.emit_selected_users();
            },
            isEmpty(obj) {
                return _.isEmpty(obj);
            },
            closeSearch() {
                this.users = [];
                this.search_add_user = false;
                this.$emit('close_search_event', true);
            },
            searchEvent: _.debounce(function (val) {
                // console.log('searchEvent', 'val', val, this);
                this.users = [];
                if (val.trim() != '' && val.trim().length > this.min_input) {
                    this.find(val.trim());
                }
            }, 600),

            find(val) {
                // console.log('find', 'val', val);

                let data = {
                    input: val
                }, self = this;

                self.search_add_user = self.searching = true;

// console.log('find', 'data',data);
                axios.post(this.search_user_uri, data)
                    .then(function (response) {
                        // console.log('response.data', response.data);
                        if (response.data.success) {
                            self.users = response.data.result;
                        }
                    })
                    .catch(function (e) {
                        console.error('e', e);
                    })
                    .then(function(){
                        self.searching = false;
                    });
            }
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/search/SearchUser.vue?6fc0b62d